// ═══════════════════════════════════════════════════════════
// localStorage 统一封装
// 所有持久化读写必须通过此模块，不允许直接访问 localStorage
// ═══════════════════════════════════════════════════════════

import { STORAGE_KEYS, CACHE_TTL } from '../config/constants.js';

// ── 底层工具 ──────────────────────────────────────────────

function get(key, fallback = null) {
    try {
        const raw = localStorage.getItem(key);
        return raw !== null ? JSON.parse(raw) : fallback;
    } catch {
        return fallback;
    }
}

function set(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
    } catch {
        return false;
    }
}

function remove(key) {
    try {
        localStorage.removeItem(key);
    } catch { /* ignore */ }
}

// ── 公开 API ──────────────────────────────────────────────

export const storage = {
    // ── API 源选择 ────────────────────────────────────────
    get apiSource() {
        return get(STORAGE_KEYS.API_SOURCE, 'hnzy');
    },
    set apiSource(v) {
        set(STORAGE_KEYS.API_SOURCE, v);
    },

    get customApiUrl() {
        return get(STORAGE_KEYS.CUSTOM_API_URL, '');
    },
    set customApiUrl(v) {
        set(STORAGE_KEYS.CUSTOM_API_URL, v);
    },

    // ── 搜索历史 ──────────────────────────────────────────
    get searchHistory() {
        return get(STORAGE_KEYS.SEARCH_HISTORY, []);
    },
    set searchHistory(v) {
        set(STORAGE_KEYS.SEARCH_HISTORY, v);
    },

    clearSearchHistory() {
        remove(STORAGE_KEYS.SEARCH_HISTORY);
    },

    // ── 观看历史 ──────────────────────────────────────────
    get watchHistory() {
        return get(STORAGE_KEYS.WATCH_HISTORY, []);
    },
    set watchHistory(v) {
        set(STORAGE_KEYS.WATCH_HISTORY, v);
    },

    clearWatchHistory() {
        remove(STORAGE_KEYS.WATCH_HISTORY);
    },

    // ── TV 模式 ────────────────────────────────────────────
    get tvMode() {
        return get(STORAGE_KEYS.TV_MODE, '0');
    },
    set tvMode(v) {
        set(STORAGE_KEYS.TV_MODE, v);
    },

    // ── 播放器状态（单对象，替代散落的 4 个 key）─────────
    get playerState() {
        return get(STORAGE_KEYS.PLAYER_STATE, {
            title: '',
            episodeIndex: 0,
            episodes: [],
            reversed: false,
        });
    },
    set playerState(v) {
        set(STORAGE_KEYS.PLAYER_STATE, v);
    },

    // ── 站点可用性缓存（带 TTL）───────────────────────────
    getSiteStatus(source, customUrl = '') {
        const key = STORAGE_KEYS.SITE_STATUS_PREFIX + source + '_' + (customUrl || '');
        const cached = get(key, null);
        if (!cached) return null;

        // 检查 TTL
        if (Date.now() - cached.timestamp > CACHE_TTL.SITE_STATUS) {
            remove(key);
            return null;
        }
        return cached.isAvailable;
    },

    setSiteStatus(source, customUrl, isAvailable) {
        const key = STORAGE_KEYS.SITE_STATUS_PREFIX + source + '_' + (customUrl || '');
        set(key, { isAvailable, timestamp: Date.now() });
    },
};

export default storage;
